// extracted by mini-css-extract-plugin
export var actions = "components-modals-__ResumeUseCard-module___actions";
export var boldStyle = "components-modals-__ResumeUseCard-module___boldStyle";